module.exports = __webpack_public_path__ + "static/media/new-logo.884cb961.png";